import { resolvedLang, setLang, useLangConfig } from "@/lib/lang";

// Sélecteur de langue du site public — module multilingue.
//
// Ne rend RIEN tant que le module n'est pas activé sur le thème de la
// boutique, ou tant qu'il n'y a qu'une seule langue : un composant invisible
// par défaut, qu'on peut donc déposer dans n'importe quel en-tête sans
// changer l'apparence des boutiques qui ne s'en servent pas.
//
// Trois codes au maximum (fr/en/ar) : des onglets côte à côte suffisent et se
// lisent d'un coup d'œil, là où un menu déroulant demanderait un clic de plus
// pour la même information.
export default function LanguageSwitcher({ className = "", linkClass = "" }) {
  const config = useLangConfig();
  // `resolvedLang` et non la langue brute : un choix qui n'est plus proposé
  // par la boutique laisserait sinon le sélecteur sans aucun onglet actif.
  const current = resolvedLang();

  if (!config.enabled || (config.languages || []).length < 2) return null;

  return (
    <div
      className={`flex items-center gap-1 ${className}`}
      role="group"
      aria-label="Choix de la langue"
      data-testid="language-switcher"
    >
      {config.languages.map((lang) => {
        const active = lang.code === current;
        return (
          <button
            key={lang.code}
            type="button"
            onClick={() => !active && setLang(lang.code)}
            aria-current={active ? "true" : undefined}
            // `lang` + `dir` sur le bouton lui-même : le nom natif d'une
            // langue s'écrit dans son propre sens, même quand la page est
            // encore dans une autre (l'arabe reste lisible sur une page
            // française).
            lang={lang.code}
            dir={lang.dir || "ltr"}
            title={lang.label}
            data-testid={`lang-${lang.code}`}
            // min-h/min-w 24px : l'audit relevait ces boutons parmi les
            // cibles tactiles trop petites. Le padding élargit la zone
            // cliquable sans changer la taille du texte, donc sans toucher au
            // rendu visuel de l'en-tête.
            className={`min-h-[24px] min-w-[24px] px-2 py-1 inline-flex items-center justify-center text-[12px] font-medium uppercase tracking-wide rounded transition-opacity ${linkClass} ${
              active ? "opacity-100 underline underline-offset-4" : "opacity-60 hover:opacity-100"
            }`}
          >
            {lang.code}
          </button>
        );
      })}
    </div>
  );
}
